import paxios from "./paxios";
import { setupCache } from "axios-cache-adapter";
import { getCurrentSubdomain } from "@/common/functions";

const ARTICLE_API = process.env.ARTICLES_API;

/** The static content being pulled from the API below
 * should eventually be pulled in from the same API as above
 */
const TMP_CMS_API = "https://api.yourdictionary.com/cms/v1/ydes/article/";

const cache = setupCache({
    debug: process.env.NODE_ENV !== "production"
});

const resource = paxios.create({
    baseURL: ARTICLE_API,
    adapter: cache.adapter
});

const tmpResource = paxios.create({
    baseURL: TMP_CMS_API,
    adapter: cache.adapter
});

const currentSubdomain = getCurrentSubdomain();

export default {
    getArticles: slug => {
        return resource.get(`/.${currentSubdomain}${slug}`);
    },
    getArticlePreview: id => {
        return resource.get(`${id}?v=${new Date().getTime()}`);
    },
    getRelatedContent(slug) {
        return resource.get(`.${currentSubdomain}${slug}/related`);
    },
    getCookiePolicy() {
        return resource.get(`.www.about.cookie`);
    },
    getSobreYDR() {
        return tmpResource.get(`.service-pages.sobre-yourdictionary?format=html`);
    },
    getContactoYDR() {
        return tmpResource.get(`.service-pages.contacto?format=html`);
    },
    getPrivacidadYDR() {
        return tmpResource.get(`.service-pages.politica-de-privacidad?format=html`);
    },
    getCondicionesYDR() {
        return tmpResource.get(`.service-pages.condiciones-de-uso?format=html`);
    },
    getCookiesYDR() {
        return tmpResource.get(`.service-pages.politica-de-cookies?format=html`);
    }
};



// WEBPACK FOOTER //
// ./src/services/CMSService.js